// Country specific JS
// All your code here should be wrapped inside functions, i.e. no code a the root of the module (beside empty variable declarations)

// here you can import other things
// import { myfunction } from './lib/mylib'
import { activateFuncionalities } from '../api/api';
import { changeShippingDelayForIconProductsArticle, changeShippingDelayForIconProductsTG, changeStylePVPR } from './listingPage/es-listing';
import {changeStyleSalesTitles} from './sportpage/sales-style';


export function init() {
  // type your code here
  // it will be executed on the DOMContentLoaded event
  const activates = activateFuncionalities('catalog');

  // fix margin bottom on listing content
  if (jQuery('.more-content').is(':visible')) {
    jQuery('.listing-page #listing-product').css('margin-bottom', '-100px');
  }

  // reset margin bottom on listing content
  jQuery('#more_product_a').click(() => {
    setTimeout(() => {
      if (jQuery('.more-content').is(':not(:visible)')) {
        jQuery('.listing-page #listing-product').css('margin-bottom', 'unset');
      }
    }, 500);
  });

  // add class to listing page and control the css properties
  jQuery('body').addClass('es-listing-page');

  // hide global average rating
  jQuery('#ajax-MC_GlobalAverageRating').hide();

  // change style gifcard button
  const giftcardButton = jQuery('.giftcard-banner .giftcard-banner__link.cta');
  giftcardButton.removeClass();
  giftcardButton.addClass('cta-v2 es-gift');
  giftcardButton.attr('data-icon', '>');

  jQuery('.giftcard-banner').css('flex-direction', 'column');

  jQuery('.giftcard-banner').prependTo('.list-last-viewed-products');

  jQuery('.product-sorting-bar').append('<div class="order-by"><span>Ordenar por:</span></div>');


  // change style for PVPR stickers
  if(activates.changeStylePVPR){
    changeStylePVPR();
  }

  /** Change style in menu and titles sportpage **/
  if(activates.changeStyleSportPageSales){
    changeStyleSalesTitles();
  }

  // check and change shipping delay for icon products
  if(activates.changeShippingDelayForIconProductsArticle){
    changeShippingDelayForIconProductsArticle();
  }
  if(activates.changeShippingDelayForIconProductsTG){
    changeShippingDelayForIconProductsTG();
  }

  jQuery(document).ajaxSuccess((event, xhr, settings) => {
    if (settings.url.split('?')[0].indexOf('jquery.twbsPagination.js') >= 0 ||
      settings.url.split('?')[0].indexOf('/ajax/loadCartridge') >= 0 ||
      settings.url.split('?')[0].indexOf('/ajax/rest/model/com/decathlon/cube/commerce/pricing/api/PricingActor/getModelPriceInformation') >= 0 ||
      settings.url.split('?')[0].indexOf('/ajax/reloadCartridgeContentCollection') >= 0) {

      if(activates.changeShippingDelayForIconProductsArticle){
        changeShippingDelayForIconProductsArticle();
      }

      if(activates.changeShippingDelayForIconProductsTG){
        changeShippingDelayForIconProductsTG();
      }

    }
  });
}



// WEBPACK FOOTER //
// ./src/_override/catalog/catalog-country.entry.js